export default {
	actionIcon: 'StarIcon',
	highlightColor: 'warning',
	data: [
    // DASHBOARDS
		// {index: 0, label: 'Analytics Dashboard', url: '/dashboard/analytics', labelIcon: 'HomeIcon', highlightAction: false},
		// { index: 1, label: 'Course Builder', url: '/CourseBuilder', labelIcon: 'Share2Icon', highlightAction: true },
		// {index: 2, label: 'Select Course', url: 'coursebuilder/BrowseCourse', labalIcon: 'gridIcon',highlightAction : false},
		// {index: 3, label: 'Backgrounds', url: '/coursebuilder/BackgroundList', labelIcon: 'ImageIcon', highlightAction: false},
		// {index: 4, label: 'Music / Audio', url: '/coursebuilder/MusicList', labelIcon: 'MusicIcon', highlightAction: false},
		// {index: 5, label: 'Scenes', url: '/coursebuilder/SceneList', labelIcon: 'FilmIcon', highlightAction: false},
		// {index: 6, label: 'Characters', url: '/coursebuilder/CharacterList', labelIcon: 'SmileIcon', highlightAction: false},
		// {index: 7, label: 'Video / Animation', url: '/coursebuilder/VideoList', labelIcon: 'VideoIcon', highlightAction: false},
	]
}
